import {request,post,get} from '@/plugins/requestU'

// 根据agentWebUrl获取agent信息
export function getAgent(data) {
    return post('/guarantee/v0.1/guarantee/agent/ta/detailByKey', data);
}